import { Button, Modal } from 'react-bootstrap';
import React from 'react';
import StudentCourseService from '../../service/studentCourseService';
import { useParams } from 'react-router-dom';
import { successNotify, errorNotify } from '../Utils/Toast';
import useToken from '../../App/useToken';

import './ApproveStudentCourseModal.css'

export default function ApproveStudentCourseModal({ showApproveStudentCourseModal, setShowApprovStudentCourseModal, courseId, getStudentCourse }) {
    const { getToken } = useToken();
    const token = getToken();
  
    const handleClose = () => {
      setShowApprovStudentCourseModal(false);
    }

    const handleOnApproveCourse = async e => {
      const studentCourseService = new StudentCourseService();
      const res = await studentCourseService.approveStudentCourse(courseId, token);
      if (res?.type == 'error') errorNotify('เกิดข้อผิดพลาด')
      getStudentCourse();
      successNotify('ส่งผลสำเร็จ');
      setShowApprovStudentCourseModal(false);
    }
    return (
      <>
        <Modal
            show={showApproveStudentCourseModal}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
          >
              <Modal.Header closeButton>
                <Modal.Title>ส่งผลการจัด</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                คุณต้องการส่งผลการจัด(หากส่งผลแล้วจะไม่สามารถแก้ไขได้)?
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                  ปิด
                </Button>
                <Button variant="primary" type='submit' onClick={handleOnApproveCourse}>บันทึก</Button>
              </Modal.Footer>
        </Modal>
      </>
    );
}